import React, { createContext, useContext, useState } from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = ({ message, variant = "success", autoHide = false, delay = 3000 }) => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, variant, autoHide, delay }]);
  };

  const removeToast = (id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  };

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}

      <ToastContainer
        position="top-end"
        className="p-3"
        style={{
          position: "fixed", // FIXED relative to viewport
          top: "70px",       // adjust for header height
          right: "20px",
          zIndex: 1050
        }}
      >
        <div style={{ position: "fixed", top: "70px", right: "20px", zIndex: 1050 }}>
        {toasts.map((t) => (
          <Toast
            key={t.id}
            onClose={() => removeToast(t.id)}
            show={true}
            bg={t.variant}
            autohide={t.autoHide}
            delay={t.delay}
            animation={true}       // smooth fade in/out
            style={{ minWidth: "250px" }}
          >
            <Toast.Header closeButton>
              <strong className="me-auto">{t.variant === "success" ? "Success" : "Notice"}</strong>
            </Toast.Header>
            <Toast.Body style={{ color: "white" }}>{t.message}</Toast.Body>
          </Toast>
        ))}
        </div>
      </ToastContainer>
    </ToastContext.Provider>
  );
};